module.exports = __webpack_public_path__ + "img/default-course-wallpaper.a01b874.jpg";